import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';
import { useDeps } from '@Contexts/DI';
import useNavigation from '@Navigation/useNavigation';
import * as ApiCategory from '@Api/Category';
import getInlineBannersKeys from './getInlineBannersKeys';

import type { InlineBannersResponse } from '@Api/Category/getInlineBanners';

export const useInlineBanners = (slug: string) => {
  const { logger } = useDeps();
  const { search } = useNavigation();
  const request = useRequest();
  const keys = getInlineBannersKeys({ slug, search, request });

  const result = useQuery<InlineBannersResponse>({
    queryKey: keys,
    queryFn: async () => {
      try {
        const inputParams = {
          slug,
          search,
        };
        const promotion = await ApiCategory.getInlineBanners(inputParams, request);

        return promotion;
      } catch (err) {
        // Этот запрос мы считаем не критичным, если произошла ошибка,
        // то допустимо отдать пустой массив данных, чтобы сохранить доступность страницы
        logger.log(err);
        return Promise.resolve(null);
      }
    },
    enabled: true,
    placeholderData: (previousData) => previousData,
  });

  return result;
};

export default useInlineBanners;
